export default __webpack_public_path__ + "static/media/sx.c2970bc4.svg";